import React, { Component } from "react";
import Header from "../../common/header";
import ScrollToTop from "../../common/scrollToTop";
import ReloadModal from "../../common/reloadModal";
import { logEvent } from "../../../services/log";

class SacredSpaces extends Component {
  componentDidMount() {
    setTimeout(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get("source");

      let referrer = sessionStorage.getItem("previousPage") || "";

      let eventToLog = "sacredspaces";

      if (source === "mobileApp") {
        eventToLog = "sacredspaces_mobile";
      } else if (referrer.includes("/home")) {
        eventToLog = "sacredspaces_home";
      } else if (referrer.includes("/schedule")) {
        eventToLog = "sacredspaces_schedule";
      }

      logEvent(eventToLog, { type: "Resource", source, referrer });
    }, 1000);

    window.scrollTo(0, 0);
  }

  handleClick = (type) => {
    const opened = window.open(this.resourceUrl, "_blank"); // Attempts to open a new tab

    // Logs immediately
    logEvent(`sacredspaces_click_${type}`, { 
      type: "ResourcePage",
    }); 

    // If pop-up blocked, fallback with delay
    if (!opened || opened.closed || typeof opened.closed === "undefined") {
      setTimeout(() => {
        window.location.href = this.resourceUrl;
      }, 250); // Small delay to log event in case of redirecting
    }
  };

  resourceUrl = "https://one.org.sg/resource/sacred-spaces-our-homes"; 
  bannerImageUrl = "https://firebasestorage.googleapis.com/v0/b/mycatholicsg-prod01.appspot.com/o/cdn%2Fbanner%2Fone%2FSacred%20Spaces%20Web%20Banner.png?alt=media&token=558b9312-6d5f-4c5a-bf02-5449281ca56e"; 
  youtubeId = "FHEDkHdKgTQ";

  render() {
    const writeup = `
      <p>Introducing a new 4-part video formation series for families, communities and individuals by the Office for the New Evangelisation </p>
    `;

    return (
      <React.Fragment>
        <Header hide="profile" type="backandlogo" />
        <ReloadModal />
        <div className="container defaultfontsize pt-3 px-3">
          {/* Banner Image with click logging */}
          <div className="text-center mb-4">
            <img
              src={this.bannerImageUrl}
              alt="Sacred Spaces Banner"
              className="img-fluid rounded pointer"
              onClick={() => this.handleClick("banner")}
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Embedded YouTube Video */}
          <div className="embed-responsive embed-responsive-16by9 mb-4">
            <iframe
              className="embed-responsive-item"
              src={`https://www.youtube.com/embed/${this.youtubeId}`}
              allowFullScreen
              title="Sacred Spaces Trailer"
            ></iframe>
          </div>

          {/* Static Write-up */}
          <div
            className="mb-4 text-dark"
            dangerouslySetInnerHTML={{ __html: writeup }}
          ></div>

          {/* CTA Button with click logging */}
          <div className="text-center mb-5">
            <button
              className="btn btn-primary btn-lg"
              onClick={() => this.handleClick("cta")}
            >
              Click here to find out more!
            </button>
          </div>

          <div className="text-center my-2">
          <a href="/home" className="py-3 defaultfontsize">
            Back to Home
          </a>
        </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SacredSpaces;